import { Component, Fragment, h, Prop } from '@stencil/core';
import { store, Unsubscribe } from '@stencil/redux';
import { isSameDay } from 'date-fns';
import { RootState } from '../../../redux/reducers';
import { dateToLocalizedStringHour, dateToLocalizedString, formatDateTimeAndLocalize, dateToHourString } from '../../../utils/utils';
import ArrowRight from '../svg-elements/arrow-right';

@Component({
  tag: 'rentware-date-output',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareDateOutput {
  @Prop() size: 'S' | 'M' = 'S';

  @Prop({ mutable: true }) fullDay: boolean;
  @Prop({ mutable: true }) pickUpDate: Date;
  @Prop({ mutable: true }) dropOffDate: Date;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        fullDay: state.orderDetails?.fullDayIntent,
        pickUpDate: !!state.orderDetails ? new Date(state.orderDetails?.fromDate) : null,
        dropOffDate: !!state.orderDetails ? new Date(state.orderDetails?.toDate) : null,
      };
    });
  }

  get singleDay() {
    return isSameDay(this.pickUpDate, this.dropOffDate);
  }

  get pickUpTime() {
    return dateToHourString(this.pickUpDate);
  }

  get dropOffTime() {
    return dateToHourString(this.dropOffDate);
  }

  get dropOffLocalizedTime() {
    return dateToLocalizedStringHour(this.dropOffDate);
  }

  get dateFromText() {
    if (this.fullDay) {
      return dateToLocalizedString(this.pickUpDate);
    } else {
      return formatDateTimeAndLocalize(this.pickUpDate, this.pickUpTime, null, true);
    }
  }

  get dateToText() {
    if (this.singleDay) {
      if (this.fullDay) {
        return null;
      } else {
        return this.dropOffLocalizedTime;
      }
    } else {
      if (this.fullDay) {
        return dateToLocalizedString(this.dropOffDate);
      } else {
        return formatDateTimeAndLocalize(this.dropOffDate, this.dropOffTime, null, true);
      }
    }
  }

  render() {
    if (!this.pickUpDate) {
      return null;
    }

    return (
      <div class={'DateContainer ' + this.size}>
        <p>{this.dateFromText}</p>

        {!!this.dateToText && (
          <Fragment>
            <ArrowRight />

            <p>{this.dateToText}</p>
          </Fragment>
        )}
      </div>
    );
  }
}
